import React, { useEffect, useState } from "react";
import Nav from "./Nav";
import Socials from "./Socials";
import NavMobile from "./NavMobile";

// import components
// import Nav from '../components/Nav';
// import NavMobile from '../components/NavMobile';
// import Socials from './Socials';
import txn_logo from "../../assets/img/logo/tXn logo.png";
const Header = () => {
  const [bg, setBg] = useState(false);

  useEffect(() => {
    window.addEventListener("scroll", () => {
      return window.scrollY > 50 ? setBg(true) : setBg(false);
    });
  });

  return (
    <header
      className={`${
        bg ? "bg-tertiary h-20 border-b border-accent" : "h-24"
      } flex  items-center fixed top-0 w-full text-white z-10 transition-all duration-300`}
    >
      <div className="container mx-auto h-full flex items-center justify-between">
        {/* logo */}
        <a href="/" className="flex flex-row gap-2 items-center">
          <img
            src={txn_logo}
            alt=""
            className="w-[40px] h-[40px] rounded-full"
          />
          <h1 className="text-2xl xl:text-3xl italic"> Tech X Neuro </h1>
        </a>
        {/* nav */}
        <div className="hidden lg:block">
          <Nav />
        </div>
        {/* Socials */}
        <div className="hidden lg:block">
          <Socials />
        </div>
        {/* nav mobile*/}
        <div className="lg:hidden">
          <NavMobile />
        </div>
      </div>
    </header>
  );
};

export default Header;
